import React, { useContext } from 'react'
import CarOverviewColor from 'app/React/Components/CarOverview/CarOverviewColor'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function CarOverviewColors({ colorsTitle, updateColorValue }) {
  const { order } = useContext(ConfiguratorContext)

  const dealerColors = order.configuration?.dealer_colors ?? []

  if (dealerColors === undefined || dealerColors.length === 0) {
    return null
  }

  return (
    <div className='car-overview__colors'>
      {colorsTitle && <p className='car-overview__colors-title'>{colorsTitle}</p>}
      {dealerColors.map((color, index) => <CarOverviewColor key={index} {...color} updateColorValue={updateColorValue}/>)}
    </div>
  )
}
